export const ROLES_ID_CONFIG = {
  ROLE_GUEST: 'ROLE_GUEST',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_USER: 'ROLE_USER',
  ROLE_SUPER_ADMIN: 'ROLE_SUPER_ADMIN'
};

export const ROLES_CONFIG = {
  ROLE_GUEST: {
    roleKey: ROLES_ID_CONFIG.ROLE_GUEST,
    menuItems: 'MENU_ITEMS_USER',
    isCreateUserFormPart: false
  },
  ROLE_USER: {
    roleKey: ROLES_ID_CONFIG.ROLE_USER,
    menuItems: 'MENU_ITEMS_USER',
    isCreateUserFormPart: true
  },
  ROLE_ADMIN: {
    roleKey: ROLES_ID_CONFIG.ROLE_ADMIN,
    menuItems: 'MENU_ITEMS_ADMIN',
    isCreateUserFormPart: true
  },
  ROLE_SUPER_ADMIN: {
    roleKey: ROLES_ID_CONFIG.ROLE_SUPER_ADMIN,
    menuItems: 'MENU_ITEMS_SUPERADMIN',
    isCreateUserFormPart: true
  }
};
